// libraries
import React from 'react'

import { roles } from './MultipleRolePicker'
import SelectWithData from './SelectWithData'

export const SelectRole = React.forwardRef((props, ref) => {
  const rolesSingular = roles.filter((r) => r.key !== 'ALL')

  return (
    <SelectWithData
      {...props}
      labelField={'label'}
      keyField={'key'}
      onChangeText={(value, userInitiated) => {
        props.onChangeText(value?.key ?? null, userInitiated)
      }}
      valueField={'value'}
      dataRows={rolesSingular}
      value={props.defaultValue}
    />
  )
})
